import MuiSvgIcon from '@mui/material/SvgIcon';

import { styled } from 'helpers';

export const SvgIcon = styled(MuiSvgIcon)`
  vertical-align: middle;
`;

export default SvgIcon;
